import { useState } from 'react';

/** Port of the DS `Avatar` — photo, or the person glyph at 50% of the box. */
export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const PX: Record<AvatarSize, number> = { xs: 20, sm: 24, md: 32, lg: 48, xl: 64 };

export interface AvatarProps {
  src?: string | null;
  name?: string;
  size?: AvatarSize;
  ring?: boolean;
  className?: string;
}

export function Avatar({ src, name, size = 'sm', ring = false, className }: AvatarProps) {
  const [failed, setFailed] = useState(false);
  const px = PX[size];
  const showImage = src && !failed;
  return (
    <div
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-[var(--hp-gray-200)] ${className ?? ''}`}
      style={{
        width: px,
        height: px,
        boxShadow: ring ? '0 0 0 2px var(--hp-cream), 0 0 0 3px rgba(143,68,32,.15)' : undefined,
      }}
    >
      {showImage ? (
        <img src={src} alt={name ?? ''} className="h-full w-full object-cover" onError={() => setFailed(true)} />
      ) : (
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true"
          className="h-1/2 w-1/2 text-[var(--hp-gray-600)]"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
          />
        </svg>
      )}
    </div>
  );
}
